import { createDatasetSlice, ResponseMapping } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import { generateApiPath } from 'src/utils';
import {
  API_GET_OMNIVERSE_SESSIONS,
  SOLUTIONS_STORE,
  SOLUTIONS_STORE_OMNIVERSE_SESSIONS,
} from '../constants';

interface ApiParams {
  solutionId: string;
  siteId: string;
  twinId?: string;
  status?: number;
  appId?: string;
  page?: number;
  pageSize?: number;
}

const api = ({
  solutionId,
  siteId,
  twinId,
  status,
  appId,
  page,
  pageSize,
}: ApiParams) => {
  const queryParams: Record<string, any> = {};

  if (twinId !== undefined) {
    queryParams.TwinId = twinId;
  }
  if (status !== undefined) {
    queryParams.Status = status;
  }
  if (appId !== undefined) {
    queryParams.AppId = appId;
  }
  if (page !== undefined) {
    queryParams.Page = page;
  }
  if (pageSize !== undefined) {
    queryParams.PageSize = pageSize;
  }

  return pepApiRequest({
    method: RequestMethod.Get,
    url: generateApiPath(API_GET_OMNIVERSE_SESSIONS, { solutionId, siteId }),
    queryParams,
  });
};

const omniverseSessions = createDatasetSlice({
  api,
  storeName: SOLUTIONS_STORE,
  actionName: SOLUTIONS_STORE_OMNIVERSE_SESSIONS,
  responseMapping: ResponseMapping.Default,
});

export default omniverseSessions;
